module.exports = __webpack_public_path__ + "static/media/Resource3.124be2f7.png";